export default "__VITE_ASSET__CRK176L5__"